import { render, staticRenderFns } from "./formStatus.vue?vue&type=template&id=3f804555"
import script from "./formStatus.vue?vue&type=script&lang=js"
export * from "./formStatus.vue?vue&type=script&lang=js"
import style0 from "./formStatus.vue?vue&type=style&index=0&id=3f804555&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports